export const setCurrentCompanyId = (companyId) => {
  if (companyId) {
    localStorage.setItem('last_company_id', String(companyId));
  }
};

/** Post-login landing — always profile; dashboards are sidebar-only. */
export const getPostLoginPath = () => '/profile';

export const getDashboardPathForCompany = (company, motherCompanyId) => {
  if (motherCompanyId && company.id === motherCompanyId) {
    return '/mother-dashboard';
  }
  return `/company-dashboard/${company.id}`;
};
